import {post} from './httpBase';

//发票订单列表
export function invoiceOrderList(params) {
    return post('/order/invoice/listorder', params)
}
//发票获取用户姓名列表
export function invoiceGetName(params) {
    return post('/order/invoice/getname', params)
}
//发票申请
export function invoiceApply(params) {
    return post('/order/invoice/apply', params)
}
//发票历史
export function invoiceRecord(params) {
    return post('/order/invoice/historylist', params)
}
//待开票发票撤回
export function invoiceBack(params) {
    return post('/order/invoice/back', params)
}
//发票详情
export function invoiceDetail(params) {
    return post('/order/invoice/details', params)
}
// 微信端发票支付
export function invoiceWeChat(params) {
    return post('/order/wxpay/unifiedorder/invoice', params)
}
// 获取历史发票信息
export function getHistorInvoiceInfo(params) {
    return post('/order/invoice/querycommon', params)
}
// 删除历史发票信息
export function deleteHistorInvoiceInfo(params) {
    return post('/order/invoice/deletecommon', params)
}
// 获取开票数量上限
export function getinvicecount(params) {
    return post('/user/companyinvoice/getinvicecount', params)
}
// 获取开票乘客信息
export function getpassengerinfo(params) {
    return post('/order/invoice/getpassengerinfo', params)
}
// 数电票作废
export function cancelInvoice(params) {
    return post('/order/invoice/cancellation', params)
}




// WEBPACK FOOTER //
// ./src/service/invoiceService.js